"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledMenuPopper = void 0;
var _MenuPopper = require("./MenuPopper");
// TODO: in v9, move styled() from MenuPopper.jsx to here
var StyledMenuPopper = _MenuPopper.MenuPopper;
exports.StyledMenuPopper = StyledMenuPopper;